import { LAYOUTS, } from '@voltmoney/types';
import { ROUTE } from '../../../routes';
import { WIDGET } from "@voltmoney/schema";
export const template = async (height, amountToBePaid) => {
    return {
        layout: {
            id: ROUTE.UPI_IN_PROGRESS,
            type: LAYOUTS.LIST,
            widgets: [
                {
                    id: "upiInProgress", type: WIDGET.UPI_IN_PROGRESS
                }
            ]
        },
        datastore: {
            upiInProgress: {
                height: height,
                principalOutstandingAmount: amountToBePaid
            },
        },
    };
};
export const upiInProgressMf = {
    onLoad: async ({ network, getHeight }, { amountToBePaid }) => {
        return Promise.resolve(template(getHeight(), amountToBePaid));
    },
};
